import { getTimeseriesAggregatedDataForDashboard } from "@src/cloud-connect/use-cases/get-timeseries-aggregate-data-for-dashboard";
import { buildAggregatedDataGraphOptionObject } from "./build-aggregated-data-graph-option-object";
import { processNodeInformation } from "./process-node-information";

export const fetchTimeseriesAggregatedDataAndBuildObjectForChart = async (
  groupId,
  tile,
  lookForLastAvailableTimeStampBeforeFetchingData,
  callback,
  setNodeInfoList,
  signal?: AbortSignal,
) => {
  const response = await getTimeseriesAggregatedDataForDashboard(
    groupId,
    tile,
    lookForLastAvailableTimeStampBeforeFetchingData,
    signal,
  );
  if (signal?.aborted) return;

  processNodeInformation({
    response,
    tile,
    setState: setNodeInfoList,
  });

  callback(
    buildAggregatedDataGraphOptionObject(
      tile.getTitle(),
      response,
      tile.getNodes(),
    ),
  );
};
